import './previous-button.scss';

import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

export const PreviousButton = (props: LoadingButtonProps) => {
  return (
    <LoadingButton
      variant="contained"
      startIcon={''}
      disabled={props.disabled}
      sx={{
        height: 40,
        width: 40,
        borderRadius: '50%',
        minWidth: 0,
        padding: 0,
        backgroundColor: '#000',
        boxShadow: 'none',
        '&.Mui-disabled': {
          color: 'white',
        },
        '&:hover': {
          backgroundColor: '#000',
          boxShadow: 'none',
        },
      }}
      {...props}
    >
      <ArrowBackOutlinedIcon />
    </LoadingButton>
  );
};
